// extracted by mini-css-extract-plugin
module.exports = {"content":"mC3ld"};